import { alpha, Button, styled } from '@mui/material';
import { FONT_DISPLAY } from 'themes/tokens';

export const TwoPaneRoot = styled('div')({
  height: '100%',
  display: 'flex',
  overflow: 'hidden',
});

export const Pane = styled('section', {
  shouldForwardProp: (prop) => prop !== 'divide',
})<{ divide?: boolean }>(({ theme, divide }) => ({
  flex: '1 1 0',
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  ...(divide && { borderRight: `1px solid ${theme.palette.divider}` }),
}));

export const PaneHeader = styled('header')(({ theme }) => ({
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(2.5, 2.75, 1.75),
}));

export const PaneHeaderTitle = styled('h3')(({ theme }) => ({
  margin: 0,
  flex: 1,
  minWidth: 0,
  fontFamily: FONT_DISPLAY,
  fontSize: '1.15rem',
  fontWeight: 700,
  letterSpacing: '-0.01em',
  color: theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const PaneScroll = styled('div')(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  padding: theme.spacing(1.5, 2.75, 2),
}));

export const PaneFooter = styled('footer')(({ theme }) => ({
  flex: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(2, 2.75),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const footerButtonBase = (theme: import('@mui/material').Theme) => ({
  borderRadius: '9px',
  fontWeight: 700,
  letterSpacing: '0.04em',
  padding: theme.spacing(1, 2),
});

export const CloseTextButton = styled(Button)(({ theme }) => ({
  ...footerButtonBase(theme),
  color: theme.palette.text.secondary,
  '&:hover': { color: theme.palette.text.primary, backgroundColor: alpha(theme.palette.primary.main, 0.08) },
}));

export const OutlinedActionButton = styled(Button)(({ theme }) => ({
  ...footerButtonBase(theme),
  color: theme.palette.info.main,
  borderColor: alpha(theme.palette.info.main, 0.4),
  '&:hover': { borderColor: theme.palette.info.main, backgroundColor: alpha(theme.palette.info.main, 0.08) },
}));

export const LimeButton = styled(Button)(({ theme }) => ({
  ...footerButtonBase(theme),
  backgroundColor: theme.palette.accent.main,
  color: theme.palette.accent.contrastText,
  '&:hover': { backgroundColor: theme.palette.accent.dark },
}));

export const BlueButton = styled(Button)(({ theme }) => ({
  ...footerButtonBase(theme),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': { backgroundColor: theme.palette.primary.dark },
}));
